import { render, staticRenderFns } from "./WaitPage.vue?vue&type=template&id=21ed26ea&scoped=true"
import script from "./WaitPage.vue?vue&type=script&lang=js"
export * from "./WaitPage.vue?vue&type=script&lang=js"
import style0 from "./WaitPage.vue?vue&type=style&index=0&id=21ed26ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed26ea",
  null
  
)

export default component.exports